/**
 * Domain constants shared across worker and web packages.
 */
export const APP_NAME = 'Fade';
export const APP_TAGLINE = 'A place where memories live forever.';
/**
 * Legacy status state machine.
 * See CLAUDE.md → "Legacy (Story) Status".
 */
export const LEGACY_STATUSES = ['draft', 'published', 'archived'];
/**
 * Allowed status transitions for a legacy entry.
 * Any state can move back to draft (author reset).
 */
export const LEGACY_TRANSITIONS = {
    draft: ['draft', 'published'],
    published: ['published', 'archived', 'draft'],
    archived: ['archived', 'published', 'draft'],
};
/**
 * Dead Man Switch defaults.
 */
export const DMS_DEFAULTS = {
    /** Default check-in interval in days. */
    checkInIntervalDays: 30,
    /** After this many days overdue, mark user as inactive. */
    inactiveAfterDays: 60,
    /** Maximum allowed check-in interval (sanity cap). */
    maxCheckInIntervalDays: 365,
    /** Minimum allowed check-in interval. */
    minCheckInIntervalDays: 1,
};
/**
 * Pagination defaults for the public feed.
 */
export const FEED_DEFAULTS = {
    pageSize: 20,
    maxPageSize: 100,
};
//# sourceMappingURL=constants.js.map